import { AjaxFormValidation } from '@common/libs/ajax-form-validation';

export const AffiliateRegistrationForm = {

    $form: $('#AffiliateRegisterForm'),

    /**
     * Bind form validation
     */
    initFormValidation(callbacks) {
        callbacks = $.extend({
            error: (response) => {}, // {function}
            success: (response) => {} // {function}
        }, callbacks);

        let self = this;
        
        let validator = new AjaxFormValidation(this.$form, '/affiliates/ajax_validate', 'default', {}, function(element, validation){
            if (element.attr('type') == 'checkbox') {
                validation.addClass('font-size-12');
                element.parent().append(validation);
            } else {
                element.after(validation);
            }
        });

        validator.fixCakeFormInput('.mb-3');
    
        // Loose URL/website validation
        $.validator.methods.website = function( value, element ) {
          return this.optional( element ) || /(?:[a-z0-9][-a-z0-9]*\.)*(?:[a-z0-9][-a-z0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,})/.test( value );
        }

        let validateInput = function(elem) {
            validator.validate(elem, {}, {
                // Disable button while server validation is in-progress
                beforeSend: function() {
                    self.$form.find('[type="submit"]').attr('disabled', true);
                }
            }).always(function(response) {
                self.$form.find('[type="submit"]').removeAttr('disabled');
            });
        };

        this.$form.on('blur', '#MemberFullName, #MemberEmail, #AffiliateAffiliatecode, #AffiliateWebsite, #acceptTerms', function(e) {
            validateInput(this);
        })
        // Form submission
        .on('click', '[type="submit"]', (e) => {
            e.preventDefault();
            if (!validator.valid()) {
               return false;
            }

            let $btn = $(e.currentTarget), $btnSubmitting = self.$form.find('.btn-submitting');

            $btn.hide();
            $btnSubmitting.show();
            self.$form.submit();
        });
        
    },

}